import { FileWarning, FlaskConical } from 'lucide-react'
import type { NavEntry } from '@/app/nav-registry'

/** Nav entries only — imported by the eager shell bundle; keep free of pages/api (H-10). */

export const deviationsNav: NavEntry = {
  label: 'Deviations',
  icon: FileWarning,
  path: '/quality/deviations',
  permission: 'deviations:read',
  order: 20,
}
export const oosNav: NavEntry = {
  label: 'OOS investigations',
  icon: FlaskConical,
  path: '/quality/oos',
  permission: 'oos:read',
  order: 21,
}
